// extracted by mini-css-extract-plugin
export default {"chats":"Chats_chats__yOmQ4"};